// extracted by mini-css-extract-plugin
module.exports = {"CarouselContainer":"Carousel_CarouselContainer__1eYjR"};